import React, { useEffect, useState } from "react";
import { useNavigate, createSearchParams, useLocation } from "react-router-dom";
import axios from "axios";
import { CircularProgress } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import {
  urlListarClientes,
  urlAtivaDesativaPagPrazo,
  urlAtivaDesativaPedirApp,
  tokenUsuario,
} from "../../../utils/constants";
import CustomPagination from "../../../components/PaginationTable";
import SwitchCustom from "../../../components/SwitchCustom.jsx";

export const TableDados = ({ nome, empresa }) => {
  const [contatos, setContatos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagina, setPagina] = useState(1);
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams2 = new URLSearchParams(location.search);

  const listarContatos = async () => {
    let filtroEmpresa = empresa;
    if (empresa !== null) {
      filtroEmpresa = empresa.id;
    } else {
      filtroEmpresa = "";
    }
    try {
      const response = await axios.post(
        `${urlListarClientes}?pagina=${pagina}`,
        {
          token: tokenUsuario,
          nome: nome,
          empresa: filtroEmpresa,
        }
      );
      return response.data;
    } catch (error) {
      return null;
    }
  };

  const alterarPagPrazo = async (id, status) => {
    try {
      const response = await axios.post(urlAtivaDesativaPagPrazo, {
        token: tokenUsuario,
        id: id,
        status: status,
      });
      return response.data;
    } catch (error) {
      return null;
    }
  };

  const alterarPedirApp = async (id, status) => {
    try {
      const response = await axios.post(urlAtivaDesativaPedirApp, {
        token: tokenUsuario,
        id: id,
        status: status,
      });
      return response.data;
    } catch (error) {
      return null;
    }
  };

  const handlePageChange = (newPage) => {
    setPagina(newPage);
    setLoading(true);
    listarContatos(newPage)
      .then((lista) => {
        const contatosFiltrados = lista.filter((item) =>
          item.nome.toLowerCase().includes(nome.toLowerCase())
        );
        setContatos(contatosFiltrados);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const alterarDados = (event) => {
    let value = event.field;
    if (value !== "pagamento_prazo" && value !== "pedir_aplicativo") {
      navigate({
        pathname: "/clientes/alterar",
        search: createSearchParams({
          id: event.id,
        }).toString(),
      });
    }
  };

  useEffect(() => {
    const run = async () => {
      setLoading(true);
      const lista = await listarContatos(pagina);
      searchParams2.set("pagina", pagina);
      const novaURL = `${location.pathname}?${searchParams2.toString()}`;
      navigate(novaURL);
      setContatos(lista);
      setLoading(false);
    };
    run();
  }, [pagina]);

  useEffect(() => {
    const run = async () => {
      setLoading(true);
      const lista = await listarContatos();
      setContatos(lista);
      setLoading(false);
    };
    run();
  }, [nome, empresa]);

  const cellPagPrazo = (status, row) => {
    return (
      <SwitchCustom
        value={status}
        onChange={(e) => {
          let ativo = e.target.checked;
          if (ativo === true) {
            ativo = 1;
          } else {
            ativo = 0;
          }
          alterarPagPrazo(row.id, ativo);
        }}
      />
    );
  };

  const cellPedirApp = (status, row) => {
    return (
      <SwitchCustom
        value={status}
        onChange={(e) => {
          let ativo = e.target.checked;
          if (ativo === true) {
            ativo = 1;
          } else {
            ativo = 0;
          }
          alterarPedirApp(row.id, ativo);
        }}
      />
    );
  };

  const cellTelefone = (row) => {
    if(row.ddd && row.telefone){
      return `${row.ddd}${row.telefone}`;
    } else {
      return `Sem número`;
    }
  };

  const columns = [
    { field: "nome", headerName: "Nome", width: 255 },
    { field: "nome_empresa", headerName: "Empresa", width: 255 },
    {
      field: "telefone",
      headerName: "Número",
      renderCell: (params) => cellTelefone(params.row),
      width: 150,
    },
    {
      field: "pagamento_prazo",
      headerName: "Pagamento a prazo",
      renderCell: (params) => cellPagPrazo(params.value, params.row),
      width: 170,
    },
    {
      field: "pedir_aplicativo",
      headerName: "Pedir pelo App",
      renderCell: (params) => cellPedirApp(params.value, params.row),
      width: 170,
    },
  ];

  return (
    <>
      <div style={{ width: "100%" }}>
        {loading ? (
          <CircularProgress
            style={{ height: "20px", width: "20px" }}
            color="primary"
          />
        ) : (
          <DataGrid
            rows={contatos}
            columns={columns}
            loading={loading}
            disableSelectionOnClick
            disableColumnMenu
            disableColumnSelector
            disableRowSelectionOnClick
            rowHeight={40}
            headerHeight={40}
            autoHeight={true}
            onCellClick={alterarDados}
            components={{
              Pagination: (props) => (
                <CustomPagination {...props} onPageChange={handlePageChange} />
              ),
            }}
          />
        )}
      </div>
    </>
  );
};
